<template>
  <el-form class="job-copy-form">
    <div style="text-align: center">
      <b style="font-size: large">{{ $t('Tool.ResetJobCopyTittle') }}</b>
    </div>
    <el-form-item :label="$t('Tool.CheckedCategory')" style="margin-top: 20px">
      <el-select v-model="checkedKey">
        <el-option v-for="item in checkedList" :key="item.value" :value="item.value" :label="item.label" />
      </el-select>
    </el-form-item>
    <div v-if="checkedKey === 'copy'">
      <div style="text-align: center">
        <p style="color: #8c939d">{{ $t('Tool.ResetJobCopyMessage') }}</p>
      </div>
    </div>
    <div v-if="checkedKey === 'provider'">
      <div style="text-align: center">
        <p style="color: #8c939d">{{ $t('Tool.AfterCheckedSelection') }}</p>
      </div>
    </div>
    <el-form-item class="save-btn">
      <el-button type="primary" @click="handleReset">{{ $t('CargoMsg.Cargo_Reset') }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'

export default {
  name: 'JobCopySetting',
  data() {
    return {
      checkedKey: 'copy',
      currentLabel: '',
      loading: null,
      checkedList: []
    }
  },
  created() {
    this.checkedList = [{ value: 'copy', label: this.$t('Tool.CopyBusiness') }, { value: 'provider', label: this.$t('Tool.FreightInsuranceProvider') }]
  },
  methods: {
    handleReset() {
      if (this.checkedKey === 'copy') {
        const lobList = ['SE', 'SI', 'AI', 'AE', 'RE', 'remoteBooking']
        const businessList = ['COST_PLAN']
        for (const lob of lobList) {
          LocalStorageUtilsNew.setConfiguration('COPY_JOB_' + lob, false)
          LocalStorageUtilsNew.setConfiguration('COPY_JOB_' + lob + '_MASTER', false)
        }
        for (const business of businessList) {
          LocalStorageUtilsNew.setConfiguration('COPY_' + business, false)
        }
        this.$message.warning(this.$t('Tool.ResetJobCopySucceed'))
      } else if (this.checkedKey === 'provider') {
        LocalStorageUtilsNew.removeConfiguration('CURRENT_INSURANCE_AGENT')
        this.$message.success(this.$t('Tool.FreightInsuranceProviderReset'))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.job-copy-form{
  max-width: 430px;
  margin: 0 auto;
  padding: 15px 0 0 0;
  box-sizing: border-box;
  .el-form-item{
    margin-bottom: 15px !important;
    /deep/ .el-form-item__label{
      font-size: 13px;
    }
    &.save-btn{
      text-align: center;
      /deep/ .el-button{
        width: 120px;
        background-color: #409EFF;
        border-color: #409EFF;
      }
    }
  }
}
</style>
